// src/utils/sarvam.js
// Transcribes a list of (already <=30s) audio segments one at a time via
// Sarvam and concatenates the results — the counterpart to
// useSegmentedRecorder, which produces those segments in the first place.
import { authFetch } from '../api';

export async function transcribeSegments(segments: Blob[], languageCode: string, mode = 'voice-input'): Promise<string> {
  const transcripts: string[] = [];
  for (const segment of segments) {
    const fd = new FormData();
    fd.append('audio', segment, 'recording.webm');
    fd.append('language_code', languageCode);
    fd.append('mode', mode);
    const res  = await authFetch('/api/voice/transcribe', { method: 'POST', body: fd });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Transcription failed');
    if (data.transcript) transcripts.push(data.transcript);
  }
  return transcripts.join(' ').trim();
}
